import './App.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom";

import {Route, Routes, HashRouter} from "react-router-dom";
import ProtectedRoute from './components/ProtectedRoutes';
import MenuLandingPage from './containers/MenuLandingPage';
import NewPackOutPage from './containers/NewPackoutPage';
import UploadFilePage from './containers/UploadFilePage';
import ChecklistPage from './containers/ChecklistPage';
import PackingListPage from './containers/PackingListPage';
import ContainerOverviewPage from './containers/ContainerOverviewPage';
import FinalPackingPage from './containers/FinalPackingPage/FinalPackingPage';
import DonePage from './containers/DonePage';
import CanvasRenderer from './components/CanvasRenderer/CanvasRenderer';
import ExpandedCanvasPage from './containers/ExpandedCanvasPage'
import Printout from './containers/Printout';
import PortraitPrintout from './containers/PortraitPrintout/NewPortraitPrintout';
import LandscapePrintout from './containers/LandscapePrintout/NewLandscapePrintout';
import CSVGenerator from './containers/CSVGenerator';
import Login from './containers/LoginPage';
import TwoFactor from './containers/TwoFactor'
import HistoryPage from './containers/HistoryPage/HistoryPage';
import DB from './db';
import * as Utils from './Utils';

const db = new DB();

function App() {
  const [scene, setScene] = useState(null);
  const [dbInitialized, setDbInitialized] = useState(false);
  const [isImperial, setIsImperial] =useState(true); //imperial is true metric is false

  useEffect(() => {
    //intitalize db
    const initializeDb = async () => {
      await db.init();
      setDbInitialized(true);
    };
    initializeDb();
  },[])

  const handleUnitChange = (newUnit) => {
    setIsImperial(newUnit);
  };


  return (
    <HashRouter>
       <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/2fa" element={<TwoFactor />} />
        <Route
          exact path="/"
          element={
            <ProtectedRoute>
              <MenuLandingPage database={db}/>
            </ProtectedRoute>
          }/>
        <Route path="/newPack" element={<ProtectedRoute><NewPackOutPage/></ProtectedRoute>} />
        <Route path="/uploadFilePage" element={<ProtectedRoute><UploadFilePage database={db} databaseInit={dbInitialized} isImperial={isImperial} onUnitChange={handleUnitChange}/></ProtectedRoute>} />
        <Route path="/checklistPage" element={<ProtectedRoute><ChecklistPage scene={scene} database={db} databaseInit={dbInitialized}/></ProtectedRoute>} />
        <Route path="/packingListPage" element={<ProtectedRoute><PackingListPage database={db} databaseInit={dbInitialized}/></ProtectedRoute>} />
        <Route path="/containerOverviewPage" element={<ProtectedRoute><ContainerOverviewPage database={db} databaseInit={dbInitialized}/></ProtectedRoute>} />
        <Route path="/finalPackingPage" element={<ProtectedRoute><FinalPackingPage scene={scene} database={db} databaseInit={dbInitialized} isImperial={isImperial}/></ProtectedRoute>} />
        <Route path="/expandedCanvasPage" element={<ProtectedRoute><ExpandedCanvasPage scene={scene} database={db} databaseInit={dbInitialized} isImperial={isImperial}/></ProtectedRoute>} />
        <Route path="/donePage" element={<ProtectedRoute> <DonePage scene={scene} database={db} databaseInit={dbInitialized}/> </ProtectedRoute>} />
        <Route path="/historyPage" element={<ProtectedRoute><HistoryPage/></ProtectedRoute>} />
        <Route path="/canvasRenderer" element={<ProtectedRoute><CanvasRenderer database={db}/></ProtectedRoute>} />
        <Route path="/printout" element={<ProtectedRoute> <Printout scene={scene} database={db}/> </ProtectedRoute>} />
        <Route path="/portraitPrintout" element={<ProtectedRoute> <PortraitPrintout scene={scene} database={db}/> </ProtectedRoute>} />
        <Route path="/landscapePrintout" element={<ProtectedRoute> <LandscapePrintout scene={scene} database={db}/> </ProtectedRoute>} />
        <Route path="/csv" element={<ProtectedRoute><CSVGenerator/></ProtectedRoute>}/>

      </Routes>
    </HashRouter>
  );

}
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<App />);

export default App;